import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import classnames from 'classnames';
import useWorklogStyles from 'components/WorklogDetails/hooks/useWorklogStyles';
import { Divider } from '@material-ui/core';
import { getContactName } from 'helpers/_helpers';
import { useArrayHistoryChanges } from 'components/WorklogDetails/hooks/useArrayHistoryChanges';
import { useGetHistoryItem } from 'components/WorklogDetails/hooks/useGetHistoryItem';
import { useGetRemovedHistoryItem } from 'components/WorklogDetails/hooks/useGetRemovedHistoryItem';
import { useMemo } from 'react';

export const SheetsContacts = ({ sheet, historyState }) => {
  const worklogClasses = useWorklogStyles();

  const renderChangedContactName = (contact, { prevState: prevContact, action } = {}) => {
    if (!historyState) return (<>{getContactName(contact)}</>);
    if (historyState && (
      (contact?._id && prevContact?._id && action !== 'removed') ||
      action === 'added'
    )) {
      return (<span className={worklogClasses.showDiff}>{getContactName(contact)}</span>)
    }
    if (historyState && (action === 'removed' || !contact?._id)) {
      return <span className={worklogClasses.showDiffRemoved}>{getContactName(prevContact)}</span>
    }
    if (historyState && !prevContact) return (<>{getContactName(contact)}</>);

    const contactName = prevContact?.hasOwnPropertyName('name')
      ? <span className={worklogClasses.showDiff}>{contact.name}</span>
      : <span>{contact.name}</span>;

    const contactTitle = prevContact?.hasOwnPropertyName('title')
      ? contact?.title
        ? (<span className={worklogClasses.showDiff}>${contact.title}</span>)
        : prevContact?.title ? (<span className={worklogClasses.showDiffRemoved}>{prevContact?.title}</span>) : null
      : <span>contact?.title</span>
    const contactEmail = prevContact?.hasOwnPropertyName('email')
      ? contact?.email
        ? (<span className={worklogClasses.showDiff}>${contact.email}</span>)
        : prevContact?.email ? (<span className={worklogClasses.showDiffRemoved}>{prevContact?.email}</span>) : null
      : <span>contact?.email</span>
    const contactPhoneNumber = prevContact?.hasOwnPropertyName('phoneNumber')
      ? contact?.phoneNumber
        ? (<span className={worklogClasses.showDiff}>${contact.phoneNumber}</span>)
        : prevContact?.phoneNumber ? (<span className={worklogClasses.showDiffRemoved}>{prevContact?.phoneNumber}</span>) : null
      : <span>contact?.phoneNumber</span>

    return (
      <>
        {contactName}{contactTitle ? ', ' + contactTitle : null}{contactEmail ? ', ' + contactEmail : null}{contactPhoneNumber ? ', ' + contactPhoneNumber : null}
      </>
    );
  }

  const [prevPrimaryContact, prevPrimaryContactAction] = useMemo(() => {
    if (!historyState?.diff?.primaryContact || (
      !historyState?.diff?.primaryContact?.length &&
      !historyState?.diff?.primaryContact?._id?.length
    )) {
      return [null, null];
    }

    if (historyState?.diff?.primaryContact?.length === 1) {
      return [null, 'added']
    }
    if (historyState?.diff?.primaryContact?.length === 3) {
      return [historyState?.diff?.primaryContact[0],'removed'];
    }
    if (historyState?.diff?.primaryContact?._id?.length === 2) {
      const prevContact = {
        _id: historyState?.diff?.primaryContact?._id[0],
        name: historyState?.diff?.primaryContact?.name?.[0],
        title: historyState?.diff?.primaryContact?.title?.[0],
        email: historyState?.diff?.primaryContact?.email?.[0],
        phoneNumber: historyState?.diff?.primaryContact?.phoneNumber?.[0],
      }
      return [prevContact, 'changed'];
    }
    return [null, null];
  }, [historyState]);


  const { addedItems: addedContacts, removedItems: removedContacts, changedItems: changedContacts } = useArrayHistoryChanges(historyState?.diff?.alternateContacts)
  const getHistoryItem = useGetHistoryItem(sheet.alternateContacts, addedContacts, changedContacts);


  const renderAlternateContact = (contact, i, options) => {
    return (
      <Grid item xs={12} lg={12}>
        <Typography
          variant="body1"
          color="textSecondary"
          className={classnames(worklogClasses.regularFontWeight, worklogClasses.paddingBottom)}
        >
          Alternate Contact {sheet.alternateContacts.length < 1 ? null : i + 1}:
        </Typography>
        <Typography variant="body1" color="textPrimary">
          {renderChangedContactName(contact, options || {})}
        </Typography>
      </Grid>
    )
  }

  return (
    <>
      {(!!sheet?.primaryContact || prevPrimaryContact || !!sheet.alternateContacts?.length || !removedContacts) && (
        <Grid item xs={12}>
          <Divider />
        </Grid>
      )}
      {(sheet?.primaryContact || prevPrimaryContact?._id) && (
        <Grid item xs={12} lg={12}>
          <Typography
            variant="body1"
            color="textSecondary"
            className={classnames(worklogClasses.regularFontWeight, worklogClasses.paddingBottom)}
          >
            Primary Contact:
          </Typography>
          <Typography variant="body1" color="textPrimary">
            {renderChangedContactName(sheet?.primaryContact, { prevState: prevPrimaryContact, action: prevPrimaryContactAction })}
          </Typography>
        </Grid>
      )}
      {sheet.alternateContacts?.map((contact, i) => (
        renderAlternateContact(contact, i, getHistoryItem(contact))
      ))}
      {removedContacts?.map((contact, i) => (
        renderAlternateContact(null, i, { prevState: contact, action: 'removed' })
      ))}
    </>
  );
};
